import { render } from "./EditForm.vue?vue&type=template&id=e604e59c&scoped=true"
import script from "./EditForm.vue?vue&type=script&lang=js"
export * from "./EditForm.vue?vue&type=script&lang=js"

import "./EditForm.vue?vue&type=style&index=0&id=e604e59c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e604e59c"]])

export default __exports__